// extracted by mini-css-extract-plugin
export var infoItem = "_rj-2";
export var title = "_rj-0";
export var value = "_rj-1";